import type {Result, UseCase} from 'framework';
import type {CatalogExercise} from '../../domain/catalog-exercise';
import type {WorkoutError} from '../../domain/errors';
import type {
  CreateCustomExerciseInput,
  ExerciseCatalogRepository,
} from '../ports/exercise-catalog.repository';

/**
 * Persists a custom exercise. Input shape is validated by the form (presentation)
 * via `CreateCustomExerciseDataValidator.standardSchema` before submit.
 */
export class CreateCustomExercise
  implements UseCase<[CreateCustomExerciseInput], CatalogExercise>
{
  constructor(private readonly repository: ExerciseCatalogRepository) {}

  execute(
    input: CreateCustomExerciseInput,
  ): Promise<Result<CatalogExercise, WorkoutError>> {
    return this.repository.createCustom(input);
  }
}
